import * as moment from "moment";

/**
 * 根据时间戳返回对应的y，m，d
 * @param  {[type]} tNum [description]
 * @return {string}      [description]
 */
export function timeToYmd(tNum, sep) {
  let date = tNum ? new Date(tNum) : new Date();
  let y = date.getFullYear() + '';
  let m = (date.getMonth() + 101 + '').substring(1);
  let d = (date.getDate() + 100 + '').substring(1);

  if (sep === '年月日') {
    return y + '年' + m + '月' + d + '日';
  } else if (typeof sep === 'string') {
    return [y, m, d].join(sep);
  } else {
    return [y, m, d].join('-');
  }
}

/**
 * 生成相关联的时间
 * 参考当前时间分别返回：
 * 三分钟之内显示 刚刚，
 * 一小时之内显示 xx分钟之前，
 * 当天显示 今天 时:分,
 * 不是当天显示 xxxx年xx月xx日 时:分
 * @param  {[type]} tNum [description]
 * @return {[type]}      [description]
 */
export function timeToRelative(tNum, curt) {
  let cur = curt ? new Date(curt) : new Date();
  let t = new Date(tNum);
  let diff = cur.getTime() - tNum;
  let re;

  let dbHours = (t.getHours() + 100 + '').substring(1);
  let dbMinutes = (t.getMinutes() + 100 + '').substring(1);

  if (diff < 180000) {
    // 3*60*1000
    re = '刚刚';
  } else if (diff < 3600000) {
    // 60*60*1000
    re = Math.round(diff / 60000) + '分钟之前';
  } else if (diff < 86400000 && t.getDate() === cur.getDate()) {
    // 24小时之内，且天数和当前是同一天
    // 24*60*60*1000
    re = '今天 ' + dbHours + ':' + dbMinutes;
  } else {
    re = timeToYmd(tNum) + ' ' + dbHours + ':' + dbMinutes;
  }
  return re;
}

/**
 * 判断当前时间是否在有效期内，不在时间内返回false，在有效期内返回相差的天数、小时、分钟
 * @param endTime 结束时间
 * @returns false | {days: number, hours: number, minutes: number}
 */
export function isTimeOk(endTime) {
  const today = moment().format('YYYY-MM-DD HH:mm:ss');
  if (moment(endTime).diff(today) <= 0) return false;
  return {
    days: moment(endTime).diff(today, 'days'),
    hours: moment(endTime).diff(today, 'hours'),
    minutes: moment(endTime).diff(today, 'minutes'),
  };
}

// 获取url?后某参数
export function getQueryString(name) {
  const search = {};
  window.location.search.substr(1).split("&").forEach(kv => {
    if (kv) {
      const kvs = kv.split("=");
      search[kvs[0]] = kvs[1];
    }
  });
  return search[name] || "";
}

// 获取url？后所有参数组成的对象
export function getUrlSearchObj() {
  const search = {};
  window.location.search.substr(1).split("&").forEach(kv => {
    if (kv) {
      const kvs = kv.split("=");
      search[kvs[0]] = kvs[1];
    }
  });
  return search || {};
}

/**
 * 检查当前设备环境，是否是android，ios，微信
 * @return {[type]} [description]
 */
export function browserEnv() {
  let ua = window.navigator.userAgent.toLowerCase();
  let isWeixin = ua.indexOf('micromessenger') !== -1;
  let isAndroid = ua.indexOf('android') !== -1;
  let isIos = (ua.indexOf('iphone') !== -1) || (ua.indexOf('ipad') !== -1);
  let isAlipay = /alipayclient/.test(ua);
  return {
    isWeixin,
    isAlipay,
    isAndroid,
    isIos,
  };
}

export function isMobile() {
  const sUserAgent = navigator.userAgent.toLowerCase();
  const bIsIpad = sUserAgent.match(/ipad/i);
  const bIsIphoneOs = sUserAgent.match(/iphone os/i);
  const bIsMidp = sUserAgent.match(/midp/i);
  const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
  const bIsUc = sUserAgent.match(/ucweb/i);
  const bIsAndroid = sUserAgent.match(/android/i);
  const bIsCE = sUserAgent.match(/windows ce/i);
  const bIsWM = sUserAgent.match(/windows mobile/i);
  return (
    bIsIpad ||
    bIsIphoneOs ||
    bIsMidp ||
    bIsUc7 ||
    bIsUc ||
    bIsAndroid ||
    bIsCE ||
    bIsWM
  );
}

/**
 * 把对象数组转换成一个对象，新对象包含了原对象数组中的各个对象。
 * 指定原对象数组中每个对象的一个属性，用它的值来作为新对象中指向各个对象的属性名。
 * eg.
 * 转换前
 * arr = [
 *    {k:'obj1',x:1,y:2,z:3},
 *    {k:'obj2',x:4,y:5,z:6}
 * ]
 *
 * arrToObj(arr, 'k');
 * 转换后
 * obj = {
 * 	ojb1: {k:'obj1',x:1,y:2,z:3},
 * 	obj2: {k:'obj2',x:4,y:5,z:6}
 * }
 *
 * @param {[type]} arr 待转换的对象数组
 * @param {[type]} key 作为对象索引的属性的属性名
 */
export function arrToObj(arr, key) {
  let i, tmp, obj = {};
  for (i = 0; i < arr.length; i++) {
    tmp = arr[i];
    if (!obj.hasOwnProperty(tmp[key])) {
      obj[tmp[key]] = tmp;
    }
  }
  return obj;
}

/**
 * 生成随机字符串
 */
export function getRandom(len, radix) {
  //获取随机数
  const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  let chars = CHARS, uuid = [], i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

/**
 * 动态加载js
 * @param url
 * @param callback
 */
export function loadScript(url, callback) {
  const queryScript = document.querySelector("[src='" + url + "']");
  if (queryScript) return callback && callback();

  let script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) { //IE
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" ||
        script.readyState === "complete") {
        script.onreadystatechange = null;
        callback && callback();
      }
    };
  } else { //Others: Firefox, Safari, Chrome, and Opera
    script.onload = function () {
      callback && callback();
    };
  }
  script.src = url;
  document.head.appendChild(script);
}

/**
 * 动态加载css
 * @param url
 */
export function loadLink(url) {
  const queryLink = document.querySelector("[href='" + url + "']");
  if (queryLink) return;

  let link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = url;
  document.head.appendChild(link);
}

/**
 * 设置session中的值
 * @param key
 * @param value
 */
export function setSession(key, value) {
  window.sessionStorage.setItem(key, value);
}

/**
 * 获取session中的值
 * @param key
 * @returns {string | null}
 */
export function getSession(key) {
  return window.sessionStorage.getItem(key);
}

/**
 * 获取session中的值并转化为json
 * @param key
 * @returns {*}
 */
export function getSessionToJson(key) {
  try {
    return JSON.parse(getSession(key));
  } catch (e) {
    return null;
  }
}

/**
 * 删除session
 * @param key
 */
export function removeSession(key) {
  window.sessionStorage.removeItem(key);
}

// 去除字符串所有标点
export function stripScript(s) {
  let pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
  let rs = "";
  for (let i = 0; i < s.length; i++) {
    rs = rs + s.substr(i, 1).replace(pattern, '');
  }
  return rs;
}

// 解决精度问题
// 加法
export function accAdd(arg1, arg2) {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}

// 减法
export function subtr(arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 * 自定义事件
 * @param eventName
 * @param cause
 * @param target
 */
export function dispatchCustomEvent(eventName, cause = "", target = document) {
  const event = document.createEvent('Event');
  event.initEvent(eventName, true, false);
  event.cause = cause;

  target.dispatchEvent(event);
}

/**
 * document中添加监听事件
 * @param event
 * @param func
 */
export function catchEvent(event, func) {
  document.addEventListener(event, func);
}

/**
 * 移除document中监听事件
 * @param event
 * @param func
 */
export function removeEvent(event, func) {
  document.removeEventListener(event, func);
}

/**
 * 获取屏幕尺寸
 * @returns {{width: number, height: number}}
 */
export function getScreenSize() {
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  };
}

// 关闭入口loading
export function removeAppLoading() {
  const appLoading = document.querySelector("#appLoading");
  if (appLoading) {
    appLoading.remove();
    document.querySelector("#appLoadingStyle").remove();
  }
}

/**
 * 序列化树形结构
 */
export function serializeTree(data, column, father) {
  column = Object.assign({}, { labelKey: 'name', valueKey: 'id', childKey: 'children' }, column);
  const { labelKey, valueKey, childKey } = column;
  let resl = [];
  data.map(d => {
    let item = {};
    if (d.hasOwnProperty(childKey))
      item = {
        title: d[labelKey],
        value: d[valueKey],
        key: d[valueKey],
        children: serializeTree((d[childKey] || []), column, d[valueKey]),
      };
    else
      item = {
        title: d[labelKey],
        value: d[valueKey],
        key: d[valueKey],
      };
    resl.push(item);
    // 下面实现一个扁平化的数组，用来方便遍历数据,每个元素都存有其父级和子级的 valueKey值
    (serializeTree._flattenArr || (serializeTree._flattenArr = [])).push({
      father,
      title: d[labelKey],
      value: d[valueKey],
      key: d[valueKey],
      children: d[childKey] ? d[childKey].map(v => v[valueKey]) : ""
    });
  });
  return resl;
}

/**
 * 序列化级联数据形结构
 */
export function serializeCascader(data, column) {
  column = Object.assign({}, { labelKey: 'label', valueKey: 'value', childKey: 'children' }, column);
  const { labelKey, valueKey, childKey } = column;
  let resl = [];
  data.forEach(d => {
    let item = {};
    if (d.hasOwnProperty(childKey))
      item = {
        label: d[labelKey],
        value: d[valueKey],
        children: serializeCascader((d[childKey] || []), column),
      };
    else
      item = {
        label: d[labelKey],
        value: d[valueKey],
      };
    resl.push(item);
  });
  return resl;
}

/**
 * 树形转换为list
 * @param data
 * @returns {Array}
 */
export function listTree(data) {
  const { children, ...attr } = data || [];
  let arr = [];
  attr.id && arr.push(attr);
  children &&
    children.map(child => {
      arr = arr.concat(listTree(child));
    });
  return arr;
}

/**
 * 简单处理react css类名
 * @param classes
 * @returns {string}
 */
export function handleClassName(classes) {
  return Object.values(classes).filter(item => item).join(' ');
}

/**
 * 生成唯一ID
 * @returns {string}
 * @constructor
 */
export function UUID() {
  let s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  return s.join('');
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if ((time + '').length === 10) {
    time = +time * 1000;
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    date = new Date(parseInt(time, 10));
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return timeStr;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}


/*
 *  10和16进制转换
 * prin 为true将10进制转为16进制
 * prin 为false将16进制转为10进制
 */
export function Sixteen_ten(str, prin) {
  if (prin) {
    str = Number(str);
    let res = str.toString(16);
    return res.length === 1 ? ('0' + res) : res;
  }

  return parseInt(str, 16);
}

export function isWeixin() {
  if (window.__wxjs_environment === 'miniprogram') {
    return false;
  }
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
}

/**
 * 循环函数，默认5s循环一次
 * @param {*} getFun 
 * @param {*} time 
 * @returns 
 */
export function intervalFun(getFun, time = 5) {
  if (!getFun) return null;
  const _time = time * 1000;
  return setInterval(getFun, _time);
}

/**
 * 复制字符串到剪切板
 * @param {string} text 
 */
export function copyStr(text) {
  // 创建input元素
  const el = document.createElement('input');
  // 给input元素赋值需要复制的文本
  el.setAttribute('value', text);
  // 防止在ios中产生缩放效果
  el.style.fontSize = '12pt';
  // 隐藏元素
  el.style.overflow = 'hidden';
  // 将input元素插入页面
  document.body.appendChild(el);
  // 选中input元素的文本
  el.select();
  // 复制内容到剪贴板
  document.execCommand('copy');
  // 删除input元素
  document.body.removeChild(el);
}

/**
 * 生成唯一值
 * @returns String
 */
export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

/**
 * 是否支持全屏
 */
export function fullScreenEnabled() {
  return (document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement);
}

/**
 * 指定元素全屏显示
 * @param dom
 */
export function openFullScreen(dom) {
  if (document.mozFullScreenEnabled) {
    return Promise.reject(new Error("全屏模式被禁用"));
  }
  let result = null;
  if (dom.requestFullscreen) {
    result = dom.requestFullscreen();
  } else if (dom.mozRequestFullScreen) {
    result = dom.mozRequestFullScreen();
  } else if (dom.msRequestFullscreen) {
    result = dom.msRequestFullscreen();
  } else if (dom.webkitRequestFullscreen) {
    result = dom.webkitRequestFullScreen();
  }
  return result || Promise.reject(new Error("不支持全屏"));
}

/**
 * 指定元素退出全屏显示
 * @param dom
 */
export function closeFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}
